import styled from "styled-components";

export const ButtonSubmit = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
`